window.SubscriptionFunnel.StepPaymentOption = {
  initialize(returningFromCheckout = false) {
    let planLength = quizData.commitmentLength;

    document.querySelectorAll("[data-plan-length]").forEach((el) => {
      el.textContent = planLength;
    });

    document.querySelectorAll("[data-month-or-months]").forEach((el) => {
      el.textContent = planLength === "1" ? "Month" : "Months";
    });

    this.handleExtraToySummaryDisplay();
    this.handleTotalPriceDisplay(returningFromCheckout);
  },

  handlePaymentOptionInputChange(event) {
    if (event.target.value === "prepaid") {
      quizData.prepaid = true;
    } else {
      quizData.prepaid = false;
    }
  },

  handlePlanPriceDisplay() {
    let priceToDisplay = "";

    if (SubscriptionFunnel.FunnelUtilities.funnel_variant === "TIERS") {
      const planTier = quizData.planTier;

      if (quizData.commitmentLength === "12") {
        if (planTier === "love") {
          priceToDisplay = twelveMonthLoveBnplDisplayPrice;
        } else if (planTier === "obsessed") {
          priceToDisplay = twelveMonthObsessedBnplDisplayPrice;
        } else if (planTier === "super-obsessed") {
          priceToDisplay = twelveMonthSuperObsessedBnplDisplayPrice;
        }
      } else if (quizData.commitmentLength === "6") {
        if (planTier === "love") {
          priceToDisplay = sixMonthLoveBnplDisplayPrice;
        } else if (planTier === "obsessed") {
          priceToDisplay = sixMonthObsessedBnplDisplayPrice;
        } else if (planTier === "super-obsessed") {
          priceToDisplay = sixMonthSuperObsessedBnplDisplayPrice;
        }
      } else if (quizData.commitmentLength === "3") {
        if (planTier === "love") {
          priceToDisplay = threeMonthLoveBnplDisplayPrice;
        } else if (planTier === "obsessed") {
          priceToDisplay = threeMonthObsessedBnplDisplayPrice;
        } else if (planTier === "super-obsessed") {
          priceToDisplay = threeMonthSuperObsessedBnplDisplayPrice;
        }
      } else {
        priceToDisplay = tryItOnceMonthBnplDisplayPrice;
      }
    } else {
      if (quizData.commitmentLength === "12") {
        priceToDisplay = twelveMonthBnplDisplayPrice;
      } else if (quizData.commitmentLength === "6") {
        priceToDisplay = sixMonthBnplDisplayPrice;
      } else {
        priceToDisplay = tryItOnceMonthBnplDisplayPrice;
      }
    }

    document.querySelectorAll("[data-plan-price]").forEach((el) => {
      el.textContent = priceToDisplay;
    });

    document.querySelectorAll("[data-prepaid-total-price]").forEach((el) => {
      el.textContent = priceToDisplay;
    });
  },

  handleExtraToySummaryDisplay() {
    const extraToySummary = document.querySelector(
      ".cart-summary-container-extra-toy"
    );

    if (extraToySummary) {
      if (quizData.extraToy === "true") {
        extraToySummary.style.display = "flex";
      } else {
        extraToySummary.style.display = "none";
      }

      this.handleExtraToyPriceDisplay(extraToySummary);
    }
  },

  handleTotalPriceDisplay(returningFromCheckout = false) {
    const TIER_KEY_MAP = {
      love: "love",
      obsessed: "obsessed",
      "super-obsessed": "superObsessed",
      "toy_only": "love", // toy_only maps to love tier (3 toys)
      "toy_only extra_toy": "obsessed", // toy_only extra_toy maps to obsessed tier (4 toys)
    };

    // Helpers
    const parseTextPrice = (selector, defaultValue = 0) => {
      const value = parseFloat(document.querySelector(selector)?.textContent.trim());
      // Use 3500 as a default anchor 1mo price in order to display savings percentages
      return isNaN(value)
        ? (SubscriptionFunnel.FunnelUtilities.subscription_type === 'BARKBOX'
            ? 3500
            : defaultValue)
        : value;
    };

    const parseDisplayPrice = (val) => {
      if (val == null) return 0; // handles null OR undefined
      const cleaned = String(val).replace(/[^0-9.\-]+/g, "");
      return Number(cleaned) || 0;
    };

    const parseDollarFirstBoxAmount = (promoType) => {
      const [dollarToken, centsToken] = promoType.split("_");
      const dollars = Number(dollarToken);

      if (!centsToken || centsToken === "FIRST") return dollars;

      const cents = Number(centsToken);
      if (Number.isNaN(cents)) return dollars;

      return Number(`${dollars}.${centsToken}`);
    };

    const formatDollar = (num) => `$${num.toFixed(2)}`;

    const calculateSavings = (base, comparison) =>
      ((base - comparison) / base) * 100;

    // Commitment & Multiplier
    const commitmentLength = Number(quizData.commitmentLength);
    const commitmentMultiplier = [6, 12].includes(commitmentLength)
      ? commitmentLength
      : 1;

    // One-Month Plan Price Selector
    let oneMoSelector = ".one-mo-price-number";
    if (SubscriptionFunnel.FunnelUtilities.funnel_variant === "TIERS") {
      const rawTier = quizData.planTier; // "love" | "obsessed" | "super-obsessed"
      oneMoSelector = `.one-mo-${rawTier}-price-number`;
    }
    const oneMonthPlanPrice = parseTextPrice(oneMoSelector);

    // Extra Toy Prices
    const extraToyPrice = parseDisplayPrice(JSON.parse(extraToyDiscountPrice));
    const prepaidExtraToyPrice = parseDisplayPrice(
      JSON.parse(extraToyPrepaidDiscountPrice)
    );
    const doubleDeluxePrice = parseDisplayPrice(JSON.parse(doubleDeluxeDiscountPrice));
    const prepaidDoubleDeluxePrice = parseDisplayPrice(
      JSON.parse(doubleDeluxePrepaidDiscountPrice)
    );
    const hasDoubleDeluxe = quizData.upsellOption === "doubleDeluxe";
    const hasExtraToy = quizData.extraToy === "true" || quizData.upsellOption === "extraToy";

    // Plan Price Map & Totals
    const planPriceMap = {
      12: {
        toy_only: parseDisplayPrice(twelveMonthLoveBnplDisplayPrice),
        "toy_only extra_toy": parseDisplayPrice(twelveMonthObsessedBnplDisplayPrice),
        love: parseDisplayPrice(twelveMonthLoveBnplDisplayPrice),
        obsessed: parseDisplayPrice(twelveMonthObsessedBnplDisplayPrice),
        superObsessed: parseDisplayPrice(
          twelveMonthSuperObsessedBnplDisplayPrice
        ),
      },
      6: {
        toy_only: parseDisplayPrice(sixMonthLoveBnplDisplayPrice),
        "toy_only extra_toy": parseDisplayPrice(sixMonthObsessedBnplDisplayPrice),
        love: parseDisplayPrice(sixMonthLoveBnplDisplayPrice),
        obsessed: parseDisplayPrice(sixMonthObsessedBnplDisplayPrice),
        superObsessed: parseDisplayPrice(
          sixMonthSuperObsessedBnplDisplayPrice
        ),
      },
      3: {
        toy_only: parseDisplayPrice(threeMonthLoveBnplDisplayPrice),
        "toy_only extra_toy": parseDisplayPrice(threeMonthObsessedBnplDisplayPrice),
        love: parseDisplayPrice(threeMonthLoveBnplDisplayPrice),
        obsessed: parseDisplayPrice(threeMonthObsessedBnplDisplayPrice),
        superObsessed: parseDisplayPrice(
          threeMonthSuperObsessedBnplDisplayPrice
        ),
      },
    };

    const tierKey = TIER_KEY_MAP["love"] || quizData.planTier;
    const totalPlanPrice = planPriceMap[commitmentLength][tierKey];
    const totalPrepaidPlanPrice = totalPlanPrice * 0.9;

    // Extra Toy Totals
    const totalExtraToyPrice = !returningFromCheckout && hasExtraToy
      ? extraToyPrice * commitmentMultiplier
      : 0;
    const totalPrepaidExtraToyPrice = !returningFromCheckout && hasExtraToy
      ? prepaidExtraToyPrice * commitmentMultiplier
      : 0;
    const totalDoubleDeluxePrice = !returningFromCheckout && hasDoubleDeluxe
      ? doubleDeluxePrice * commitmentMultiplier
      : 0;
    const totalPrepaidDoubleDeluxePrice = !returningFromCheckout && hasDoubleDeluxe
      ? prepaidDoubleDeluxePrice * commitmentMultiplier
      : 0;

    // UI UPDATES
    const setTextContent = (selector, value) =>
      document.querySelectorAll(selector).forEach((el) => {
        el.textContent = formatDollar(value);
      });

    setTextContent(
      "[data-payment-total-price]",
      totalPlanPrice + totalExtraToyPrice + totalDoubleDeluxePrice
    );
    setTextContent(
      "[data-prepaid-total-price]",
      totalPrepaidPlanPrice + totalPrepaidExtraToyPrice + totalPrepaidDoubleDeluxePrice
    );

    setTextContent(
      "[data-prepaid-monthly-price]",
      (totalPrepaidPlanPrice + totalPrepaidExtraToyPrice + totalPrepaidDoubleDeluxePrice) / commitmentLength
    );
    setTextContent(
      "[data-bark-pay-monthly-price]",
      (totalPlanPrice + totalExtraToyPrice + totalDoubleDeluxePrice) / commitmentLength
    );

    // First Order Promo Price
    if (SubscriptionFunnel.FunnelUtilities.promo_type?.includes('DOLLAR_FIRST_BOX')) {
      let firstOrderPromoPrice = parseDollarFirstBoxAmount(
        SubscriptionFunnel.FunnelUtilities.promo_type
      );

      if (hasExtraToy) {
        firstOrderPromoPrice += extraToyPrice;
      } else if (hasDoubleDeluxe) {
        firstOrderPromoPrice += doubleDeluxePrice;
      }

      const formattedPromoPrice = formatDollar(firstOrderPromoPrice);
      const displayPromoPrice = formattedPromoPrice.endsWith("00")
        ? `$${Math.round(firstOrderPromoPrice)}`
        : formattedPromoPrice;

      document
        .querySelectorAll("[data-bark-promo-price]")
        .forEach((el) => {
          el.textContent = displayPromoPrice;
        });

      const standardPrepaidTotal =
        totalPrepaidPlanPrice +
        totalPrepaidExtraToyPrice +
        totalPrepaidDoubleDeluxePrice;
      const standardPrepaidMonthlyPrice = standardPrepaidTotal / commitmentLength;
      const totalPrepaidPromoPrice =
        standardPrepaidTotal - standardPrepaidMonthlyPrice + firstOrderPromoPrice;

      setTextContent(
        "[data-bark-prepaid-promo-price]",
        totalPrepaidPromoPrice
      );

      setTextContent(
        "[data-prepaid-promo-monthly-price]",
        totalPrepaidPromoPrice / commitmentLength
      );
    }

    // Savings & Interest Rates
    const totalAnchorPrice = (oneMonthPlanPrice * commitmentMultiplier) / 100;
    const prepaidSavings = calculateSavings(
      totalAnchorPrice + totalExtraToyPrice + totalDoubleDeluxePrice,
      totalPrepaidPlanPrice + totalPrepaidExtraToyPrice + totalPrepaidDoubleDeluxePrice
    );

    document
      .querySelectorAll("[data-prepaid-percent-savings]")
      .forEach((el) => {
        el.textContent = prepaidSavings.toFixed(2);
      });
  },

  handleExtraToyPriceDisplay(extraToySummary) {
    const extraToyPrice = Number(JSON.parse(extraToyDiscountPrice));
    let priceToDisplay = "";

    if (quizData.commitmentLength === "12") {
      priceToDisplay = `$${(extraToyPrice * 12).toString()}`;
    } else if (quizData.commitmentLength === "6") {
      priceToDisplay = `$${(extraToyPrice * 6).toString()}`;
    } else if (quizData.commitmentLength === "3") {
      priceToDisplay = `$${(extraToyPrice * 3).toString()}`;
    } else {
      priceToDisplay = `$${extraToyPrice.toString()}`;
    }

    document.querySelectorAll("[data-extra-toy-price]").forEach((el) => {
      el.textContent = priceToDisplay;
    });
  },

  validatePaymentOptionSelection() {
    const selectedOption = document.querySelector(
      `#select-payment-option .payment-option input:checked`
    );
    if (!selectedOption) {
      document
        .querySelector(`#select-payment-option .form-input-text-error-message`)
        .classList.remove("display-none");
      document
        .querySelectorAll("#select-payment-option .payment-option-card")
        .forEach((el) => {
          el.classList.add("card--error");
        });
      return false;
    }

    SubscriptionFunnel.FunnelNavigation.nextStep();
  },
};
